export default {
  path: '/',
  redirect: {
    name: 'visual',
  },
};
